export var LINK_SEVERITY;
(function (LINK_SEVERITY) {
    LINK_SEVERITY["COLORLESS"] = "colorless";
    LINK_SEVERITY["COLORFUL"] = "colorful";
    LINK_SEVERITY["UNDERLINED"] = "underlined";
})(LINK_SEVERITY || (LINK_SEVERITY = {}));
//# sourceMappingURL=constants.js.map